import React, { useState, useEffect } from 'react';
import './App.css';
import TranslationForm from './components/TranslationForm';
import TranslationHistory from './components/TranslationHistory';
import { translateText } from './services/translationService';
import { loadHistory, saveHistory } from './services/storageService';

function App() {
  const [history, setHistory] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Load history from localStorage on mount
  useEffect(() => {
    const savedHistory = loadHistory();
    setHistory(savedHistory);
  }, []);

  // Save history to localStorage whenever it changes
  useEffect(() => {
    saveHistory(history);
  }, [history]);

  const handleTranslate = async (text, sourceLang, targetLang) => {
    if (!text.trim()) {
      setError('翻訳するテキストを入力してください');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const translatedText = await translateText(text, sourceLang, targetLang);
      
      const newEntry = {
        id: Date.now(),
        original: text,
        translated: translatedText,
        sourceLang,
        targetLang,
        timestamp: new Date().toISOString(),
      };

      setHistory([newEntry, ...history]);
    } catch (err) {
      setError('翻訳に失敗しました。もう一度試してください。');
      console.error('Translation error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteEntry = (id) => {
    setHistory(history.filter(entry => entry.id !== id));
  };

  const handleClearAll = () => {
    if (window.confirm('すべての履歴を削除してもよろしいですか？')) {
      setHistory([]);
    }
  };

  const filteredHistory = history.filter(entry => {
    const trimmedQuery = searchQuery.trim().toLowerCase();
    
    if (!trimmedQuery) {
      return true; // Show all if search is empty
    }
    
    const matchesQuery = 
      entry.original.toLowerCase().includes(trimmedQuery) ||
      entry.translated.toLowerCase().includes(trimmedQuery);
    
    return matchesQuery;
  });

  return (
    <div className="app">
      <header className="app-header">
        <h1>📚 Translation Trail</h1>
        <p>英語学習の道を記録しよう</p>
      </header>

      <main className="app-main">
        <section className="history-section">
          <TranslationHistory
            entries={filteredHistory}
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
            onDelete={handleDeleteEntry}
            onClearAll={handleClearAll}
            totalEntries={history.length}
          />
        </section>
      </main>

      <footer className="app-footer">
        <p>© 2026 Translation Trail. Made with ❤️</p>
      </footer>

      <div className="form-spacer"></div>

      <section className="form-section">
        <TranslationForm
          onTranslate={handleTranslate}
          loading={loading}
          error={error}
        />
      </section>
    </div>
  );
}

export default App;
